(function () {
  function getSelectedVariantId(root) {
    // Most themes keep the selected variant id in the product form input[name="id"]
    var form = (root || document).querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('[name="id"]');
    return idInput ? String(idInput.value) : null;
  }

  function updateVariantMetafields(root) {
    root = root || document;
    var variantId = getSelectedVariantId(root);
    if (!variantId) return;

    var nodes = root.querySelectorAll('[data-variant-metafield]');
    if (!nodes.length) return;

    nodes.forEach(function (el) {
      var elVariantId = el.getAttribute('data-variant-metafield');
      if (elVariantId === variantId) {
        el.classList.remove('hidden');
        el.hidden = false;
      } else {
        el.classList.add('hidden');
        el.hidden = true;
      }
    });
  }

  function hook(root) {
    root = root || document;

    // Run once on load
    updateVariantMetafields(root);

    // Re-run on any change (covers most theme selector implementations)
    document.addEventListener('change', function () {
      window.setTimeout(function () {
        updateVariantMetafields(root);
      }, 0);
    });

    // Common theme custom events (Enterprise / Clean Canvas variants)
    document.addEventListener('variant:change', function () { updateVariantMetafields(root); });
    document.addEventListener('variant:changed', function () { updateVariantMetafields(root); });

    // Fallback: watch the variant id input for changes
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput && window.MutationObserver) {
      new MutationObserver(function () { updateVariantMetafields(root); })
        .observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hook(document); });
  } else {
    hook(document);
  }
})();